import { render } from "./AppClassCategorySelector.vue?vue&type=template&id=3ec0fef3&scoped=true"
import script from "./AppClassCategorySelector.vue?vue&type=script&lang=js"
export * from "./AppClassCategorySelector.vue?vue&type=script&lang=js"

import "./AppClassCategorySelector.vue?vue&type=style&index=0&id=3ec0fef3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec0fef3"]])

export default __exports__